import { getHandleFromCookie } from '@sxm-de/dev-kits/web-sdk/utils';

export type HandleFn = () => string | null;

export function initHandleFn(): HandleFn {
    return () => {
        return getHandleFromCookie();
    };
}
